module.exports = __webpack_public_path__ + "static/media/logo-white.944ae862.png";